import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import "./assets/css/main.css";
import VueImg from "v-img";
import VueSweetalert2 from "vue-sweetalert2";
import VueLazyload from "vue-lazyload";

Vue.prototype.$bus = new Vue();
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require("@/assets/img/error.png"),
  // loading: require("@/assets/img/loading.gif"),
  attempt: 1,
});
Vue.use(VueImg, {
  altAsTitle: true,
  showCloseButton: true,
});
Vue.use(VueSweetalert2);
library.add(fas, far, fab);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
